<template>
  <b-modal
    v-model="visible"
    :title="title"
    centered
    hide-footer
    dialog-class="scope-dialog"
    @hide="onHide"
  >
    <p class="scope-intro">รายการนี้เป็นตารางที่ทำซ้ำ ต้องการให้มีผลกับ?</p>
    <div class="scope-opts">
      <button
        v-for="opt in options"
        :key="opt.value"
        type="button"
        :class="['scope-opt', { on: scope === opt.value }]"
        @click="scope = opt.value"
      >
        <span class="radio"></span>
        <span class="txt">
          <span class="o1">{{ opt.title }}</span>
          <span class="o2">{{ opt.sub }}</span>
        </span>
      </button>
    </div>
    <div class="scope-foot">
      <button type="button" class="sbtn" @click="cancel">ยกเลิก</button>
      <button type="button" class="sbtn solid" @click="confirm">ตกลง</button>
    </div>
  </b-modal>
</template>

<script>
import moment from "moment";

export default {
  name: "ScopeDialog",
  data() {
    return {
      visible: false,
      scope: "day",
      date: null,
      title: "ใช้การเปลี่ยนแปลงกับ?",
      resolver: null,
    };
  },
  computed: {
    dateLabel() {
      return this.date
        ? moment(this.date).locale("en").format("D MMM YYYY")
        : "";
    },
    options() {
      return [
        {
          value: "day",
          title: "วันนี้เท่านั้น",
          sub: `เฉพาะ ${this.dateLabel} — สร้างข้อยกเว้น`,
        },
        // "following" requires the backend rrule parser to honor UNTIL/DTSTART so
        // the truncated rule actually stops (see working-hours-backend-handoff.md).
        {
          value: "following",
          title: "วันนี้และวันถัดไป",
          sub: `${this.dateLabel} เป็นต้นไป — แยกตารางใหม่`,
        },
        { value: "all", title: "ทุกครั้ง", sub: "แก้ทั้งตารางประจำ" },
      ];
    },
  },
  methods: {
    // Returns a Promise that resolves to 'day' | 'following' | 'all' | null.
    show({ date, title } = {}) {
      this.date = date || null;
      this.scope = "day";
      if (title) this.title = title;
      this.visible = true;
      return new Promise((resolve) => {
        this.resolver = resolve;
      });
    },
    confirm() {
      this.resolve(this.scope);
      this.visible = false;
    },
    cancel() {
      this.visible = false; // triggers onHide -> resolve(null)
    },
    onHide() {
      this.resolve(null);
    },
    resolve(value) {
      if (this.resolver) {
        this.resolver(value);
        this.resolver = null;
      }
    },
  },
};
</script>

<style scoped>
.scope-intro {
  font-size: 13px;
  color: #6c7888;
  margin-bottom: 14px;
}
.scope-opts {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.scope-opt {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  text-align: left;
  width: 100%;
  border: 1px solid #dde3ec;
  background: #fff;
  border-radius: 12px;
  padding: 12px 14px;
  cursor: pointer;
  transition: 0.14s;
}
.scope-opt:hover {
  border-color: #c3ccda;
}
.scope-opt.on {
  border-color: #2563eb;
  background: #eef3ff;
}
.scope-opt .radio {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #c3ccda;
  flex: none;
  margin-top: 1px;
  transition: 0.14s;
  position: relative;
}
.scope-opt.on .radio {
  border-color: #2563eb;
}
.scope-opt.on .radio::after {
  content: "";
  position: absolute;
  inset: 3px;
  border-radius: 50%;
  background: #2563eb;
}
.scope-opt .txt {
  display: flex;
  flex-direction: column;
}
.scope-opt .o1 {
  font-size: 14px;
  font-weight: 600;
  color: #192231;
}
.scope-opt .o2 {
  font-size: 11.5px;
  color: #9aa6b6;
  margin-top: 2px;
}
.scope-foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 18px;
}
.sbtn {
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid #dde3ec;
  background: #fff;
  color: #3f4a5a;
  border-radius: 10px;
  padding: 9px 16px;
  transition: 0.14s;
}
.sbtn:hover {
  border-color: #c3ccda;
}
.sbtn.solid {
  background: #2563eb;
  color: #fff;
  border-color: transparent;
}
.sbtn.solid:hover {
  filter: brightness(1.04);
}
</style>
